export default __webpack_public_path__ + "static/business_1-9228c562886f9bfff1ae45e45b15f474.png";